export const copy = {
  activeFilter: 'active filter',
  filters: 'Filters',
  hideFilters: 'Hide Filters',
  showFilters: 'Show Filters',
  rowsPerPage: 'Rows per page',
  user: 'user',
  viewMore: 'VIEW MORE',
  viewLess: 'VIEW LESS',
  add: 'ADD',
  removeAll: 'REMOVE ALL',
};
